import { LitElement, css, html } from 'lit';
import { customElement, property } from 'lit/decorators';

import { ChallengeActivity } from '../types';

@customElement('basic-activity-card')
export class BasicActivityCard extends LitElement {
    static amplitude_callsite: string = 'Basic Activity Card';

    @property({ type: Object })
    challenge_activity: ChallengeActivity | undefined;

    @property({ type: Boolean })
    completed: boolean = false;

    @property({ type: Boolean })
    vertical: boolean = false;

    @property({ type: String })
    pillText?: string;

    private async onCardClick() {
        this.dispatchEvent(new CustomEvent('on-card-click'));
    }

    render() {
        return html`
            <div class="mini-point-card" role="button" tabindex="0" aria-label="${this.challenge_activity?.name ?? 'Activity'}" @click="${this.onCardClick}" @keydown=${(e: KeyboardEvent) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); void this.onCardClick(); }}}>
                <div class="mini-point-card__image-wrapper wrapper-icon">
                    <img src=${this.challenge_activity?.image_url ?? ''} class="mini-point-card__icon" alt=""/>
                    </div>
                <div class="mini-point-card__content_image">
                    <span class="mini-point-card__category-wrapper">
                        <span class="mini-point-card__category-pill">
                            ${this.challenge_activity?.point_value} ${this.challenge_activity?.point_value === 1 ? 'point' : 'points'}
                        </span>
                        ${this.pillText ?
                            html`<span class="mini-point-card__category-pill" style="border-color: var(--main-primary-color); color: var(--main-primary-color);">
                                    ${this.pillText}
                                </span>`
                            : ''
                        }
                    </span>
                    <span class="mini-point-card__title-text">
                        ${this.challenge_activity?.name}
                    </span>
                    <span class="mini-point-card__address">
                        ${this.challenge_activity?.description}
                    </span>
                </div>
            </div>
        `;
    }

    static get styles() {
        return css`
            :host {
                --mdc-typography-button-text-transform: case;
                --mdc-typography-subtitle1-font-size: 12px;
                --mdc-icon-button-size: 36px;
                --mdc-typography-button-letter-spacing: 0px;
            }

            .mini-point-card {
                word-wrap: break-word;
                border-radius: 4px;
                display: flex;
                height: 80px;
                cursor: pointer;
                overflow-y: auto;
                box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.06) 0px 2px 4px -1px;
                gap: 8px;
            }

            .mini-point-card:focus-visible {
                outline: 2px solid var(--main-primary-color, #005fcc);
                outline-offset: 2px;
            }

            .mini-point-card__content_image {
                padding: 6px 16px 6px 8px;
                width: 60%;
                background: var(--theme-white-color);
                overflow: hidden;
                opacity: 0.98;
                flex: 1;
                padding-left: 3px;
                display: flex;
                flex-direction: column;
                gap: 4px;
            }

            .mini-point-card__content_no_image {
                padding: 12px 16px;
                width: 100%;
                background: white;
                overflow: hidden;
                opacity: 0.98;
            }

            .mini-point-card__image {
                width: 100%;
                height: 100%;
                object-fit: cover;
                opacity: 1;
            }

            .mini-point-card__icon {
                height: 75%;
                width: auto;
                opacity: 1;
                background-color: var(--theme-border-color);
            }

            .mini-point-card__point-number {
                margin-right: 2px;
                z-index: 1;
            }

            .mini-point-card__description {
                color: var(--theme-lighter-text-color);
                display: block;
                margin-bottom: 8px;
                overflow: hidden;
                text-overflow: ellipsis;
                height: 55px;
            }

            .mini-point-card__cover {
                height: 40px;
                background: linear-gradient(to top, white, transparent 100%);
                margin-top: -50px;
                padding: 5px;
                width: 100%;
                margin-left: -5px;
                position: relative;
            }

            .mini-point-card__category-wrapper {
                display: flex;
                gap: 5px;
                white-space: nowrap;
            }

            .mini-point-card__category-pill {
                border-radius: 20px;
                font-size: 12px;
                padding: 2px 6px;
                gap: 3px;
                display: flex;
                align-items: center;
                border: 1px solid var(--theme-border-color);
            }

            .mini-point-card__image-wrapper {
                display: flex;
                width: 25%;
                background-color: var(--theme-white-color);
                overflow: hidden;
                align-items: center;
                opacity: 0.98;
            }

            .wrapper-icon {
                background-color: var(--theme-border-color);
                justify-content: center;
            }

            .space-wrapper {
                flex: 1;
                background-color: var(--theme-white-color);
            }

            .mini-point-card__title-text {
                font-weight: 700;
                font-size: 14px;
                color: var(--main-primary-color);
                text-overflow: ellipsis;
                white-space: nowrap;
                overflow: hidden;
            }

            .mini-point-card__address {
                color: var(--theme-lighter-text-color);
                display: block;
                text-overflow: ellipsis;
                white-space: nowrap;
                overflow: hidden;
            }

            .mini-point-card__event {
                color: var(--theme-lighter-text-color);
                text-overflow: ellipsis;
                white-space: nowrap;
                overflow: hidden;
            }

            .mini-point-card__event-icon {
                vertical-align: middle;
                --mdc-icon-size: 20px;
                width: 16px;
                padding-right: 4px;
            }

            .mini-point-card__title--featured {
                color: var(--main-featured-color);
                align-self: center;
                padding-right: 4px;
            }

            .mini-point-card__title {
                display: flex;
            }

            .deselect-control {
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                padding: 1rem;
                gap: 0.25rem;
                cursor: pointer;
                background-color: var(--theme-opacity-background-color);
                color: var(--main-primary-color);
                --mdc-icon-size: 2rem;
                font-size: 14px;
            }
        `;
    }
}